import React, { useState, useEffect } from "react";
import Template from "../../../components/Template";
import _ from "lodash";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../../components/Button";
import Snackbar from "../../../components/Snackbar";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "../../common.css";
import useToken from "../../../hooks/useToken";
import {
  getCertificationDetailsList,
  getcertificatedetails,
  getcertificateupdate,
  getcertificationbodycreate,
  getcertificationcreate,
  getcreateAuditlog,
  getcreatenotification,


  
} from "../../../apis"; //getMRINDetail
import SimpleModal from "../../../components/Modal";
import BasicTable from "../../../components/BasicTable";
import { colors } from "../../../constants/colors";
import roles from "../../../constants/roles";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import moment from "moment-timezone";
import { routeBuilder } from "../../../utils/routeBuilder";
import ViewAuditLog from "./ViewAuditLog";
import { auditparams, defaultauditpayload } from "../../common";
import { certificationStrings, commonStrings } from "../../../components/StringBundle";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    "& .MuiGrid-grid-sm-5 .MuiFormControl-fullWidth": {
      width: "100%",
    },
    "& .page-header": {
      width: "100%",
      marginBottom: 15,
    },
    "& .MuiAccordion-root": {
      width: "100%",
    },
    "& .dispatchTable": {
      maxHeight: "400px",
      overflowY: "auto",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
  },
  modal: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "auto",
    top: "50%",
    right: "50%",
    transform: "translate(50%, -50%)",
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #fefefe",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll",
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  modal1: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "auto",
    top: "50%",
    right: "50%",
    transform: "translate(50%, -50%)",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #fefefe",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll",
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  otherModal: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: colors.orange,
    color: colors.white,
    minWidth: 50,
    textTransform: "capitalize",

    "&:hover": {
      backgroundColor: colors.orange,
      opacity: 0.8,
    },
    "& $MuiButton-label": {
      margin: 0,
    },
  },
  fileInput: {
    "& input[type='file']": {
      padding: "10px 14px",
      cursor: "pointer",
      height: "auto",
      lineHeight: "1.5",
    },
  },
  actionRow: {
    margin: 24,
  },
}));

let status = [
  { status: "ACTIVE" },
  { status: "INITIATED" },
  { status: "AUDIT COMPLETE" },
];

const formatDate = (datestr) => {
  let dateVal = new Date(datestr);
  return (
    dateVal.getFullYear() +
    "-" +
    (dateVal.getMonth() + 1) +
    "-" +
    dateVal.getDate()
  );
};

const formatToSelection = (data = [], key, id) => {
  let formattedData = [];
  data.map((v) =>
    formattedData.push({ label: v[key], value: v[id] || v[key] })
  );
  return formattedData;
};

let companyNameToEdit = "";

const EditCertification = (props) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { certificationId } = useParams();

  const [certificationDetails, setCertificationDetails] = useState({});
  const [locationList, setLocationList] = useState([]);
  const [certificationList, setcertificationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [showSnack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [disableInvoice, setDisableInvoice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState({});
  const [disableCreate, setDisableCreate] = useState(false);
  const [documentUpdated, setDocumentUpdated] = useState(false);
  const [uploadedFile, setUploadedFile] = useState({});
  const { getCurrentUserDetails } = useToken();
  const [oldData, setoldData] = useState({});
  const [logData, setLogData] = useState([]);
  const certificationFields = certificationStrings.forms;
  const certificationsFields = certificationStrings.view;
  const certificationSections = certificationStrings.sections;

  const [openAddCertificationBody, setOpenAddCertificationBody] =
    useState(false);
    let currentUserDetails = getCurrentUserDetails();


  useEffect(() => {
    const apicall = async () => {
      fetchData();
    }
    apicall();
  }, []);

  async function fetchData() {
    await fetchViewData();
    try {
      let response = await getCertificationDetailsList();
      if (response) {
        // setLocationList(
        //   response?.loaction_details === null ? [] : response?.loaction_details
        // );
        let locations = response?.loaction_details === null ? [] : response?.loaction_details;
        if (companyNameToEdit === "NCL") {
          locations = locations?.filter(
            (loc) => loc.entityname?.toLowerCase() === "nccl"
          );
        } else {
          locations = locations?.filter(
            (loc) => loc.entityname?.toLowerCase() !== "nccl"
          );
        }
        setLocationList(locations);
        setcertificationList(
          response?.certification_list === null
            ? []
            : response?.certification_list
        );
        setCountryList(
          response?.country_list === null ? [] : response?.country_list
        );
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }
  }

  const fetchViewData = async () => {
    try {
      let response = await getcertificatedetails(certificationId);
      if (response) {
        let data = response?.certification_info[0];
        let temp = {
          ...data,
          location: {entityname: data.location},
          status: {status: data.status},
          certificationBody: {certification_name: data.certification_name, cert_body_id: data.cert_body_id},
        };
        companyNameToEdit = data.company_name
        setCertificationDetails(temp);
        setoldData(temp);
        // setUploadedFile({name: temp?.doc_name})
        setUploadedFile({ name: temp?.doc_name });
        setLogData([{description:'Certification', created_user_id: temp?.created_by, created_date: formatDate(temp?.created_date), modified_user_id: temp?.modified_by, modified_date: formatDate(temp?.modified_date) }])
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }
  }

  const handleChange = (val, key) => {
    setCertificationDetails({
      ...certificationDetails,
      [key]: val,
    });
  };

  const handleChangeLocation = (event, value) => {
    console.log('value::', value)
    setCertificationDetails({
      ...certificationDetails,
      location: value,
    });
  };

  const handleChangeCountry = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      country: value,
    });
  };

  const handleChangestatus = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      status: value,
    });
  };
  const handleChangeBody = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      certificationBody: value,
    });
  };

  const handleDateChange = (date, key) => {
    if(key === 'expiry_date') {
      let temp = {};
      temp = {
        ...certificationDetails,
        [key]: date,
        alert_initation_date1: convertDateintoTZ(new Date(new Date(date).setDate(new Date(date).getDate() - 60))),
        alert_initation_date2: convertDateintoTZ(new Date(new Date(date).setDate(new Date(date).getDate() - 30))),
      };
      console.log('temp:44',temp,date)
      setCertificationDetails(temp);  
    } else {
        setCertificationDetails({
          ...certificationDetails,
          [key]: date,
        });  
    }

  };

  function bytesToMegaBytes(bytes) {
    return bytes / (1024 * 1024);
  }
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleFileChange = async (e) => {
    if (!e.target.files) {
      return;
    }
    // setDisableUpload(false);
    let file = await toBase64(e.target.files[0]);
    file = file.replace(/^data:application\/(pdf);base64,/, "");
    file = file.replace(
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
      ""
    );
    console.log("file::", file, bytesToMegaBytes(e.target.files[0].size));
    var filesize = bytesToMegaBytes(e.target.files[0].size);
    setUploadedFile({
      name: e.target.files[0].name,
      filesize: filesize,
      file: file,
    });
    setCertificationDetails({...certificationDetails, doc_name: e.target.files[0].name})
    setDocumentUpdated(true);
  };

  const AddCertifictaionBody = () => {
    setOpenAddCertificationBody(!openAddCertificationBody);
  };

  const payload4 = [
    {
      label: certificationFields.certification_body,
      type: "input",
      required: true,
      value: certificationDetails.certification_name,
      error: validationError?.certification_name,
      helperText: validationError?.certification_name,
      onChange: (e) => handleChange(e.target.value, "certification_name"),
      style: { marginTop: "10px" },
      sm: 12,
    },
    {
      label: certificationFields.country,
      required: true,
      type: "autocomplete",
      labelprop: "country_name",
      value: certificationDetails.country,
      error: validationError?.country,
      helperText: validationError?.country,
      options: countryList || [],
      onChange: handleChangeCountry,
      style: { marginTop: "20px", marginBottom: "20px" },
      sm: 12,
    },
  ];

  function convertDateintoTZ(dt) {
    var currentimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment(dt).tz(currentimeZone).format()
  }

  async function CerificationAction(e) {
    // e.preventDefault();

    const message = commonStrings.pleaseEnterValidDetails;
    let errorObj = {};
    if (_.isEmpty(certificationDetails.certification_name)) {
      errorObj = { ...errorObj, certification_name: message };
    }
    if (_.isEmpty(certificationDetails.country)) {
      errorObj = { ...errorObj, country: message };
    }
    

    setValidationError(errorObj);
    // if (!_.isEmpty(errorObj)) {
    //   setValidationError(errorObj);
    // }
    if (!_.isEmpty(errorObj)) {
      try {
        setValidationError(errorObj);
        const errorMessage = { message: commonStrings.fieldMissed };
        throw errorMessage;
      } catch (err) {
        setSnack({
          open: true,
          message: commonStrings.pleaseAllRequiredFields,
          //  err.response?.data,
          severity: "error",
        });
      }
    } else {
      setLoading(true);
      setDisableCreate(true);
    }
    let data = {
      certification_name: certificationDetails.certification_name,
      country: certificationDetails.country?.country_name,
      created_by: currentUserDetails.id,
    };
    console.log("dataaa::", data);
    try {
      let response = await getcertificationbodycreate(data);
      if (response) {
        setSnack({
          open: true,
          message: certificationFields.certificationBodySuccess,
        });
        await fetchData();
        setOpenAddCertificationBody(!openAddCertificationBody);
        let temp = { ...certificationDetails };
        delete temp.country;
        delete temp.certification_name;
        setCertificationDetails(temp);
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    } finally {
      setLoading(false);
    }


  }

  async function CertificationCancel() {
    let temp = { ...certificationDetails };
    delete temp.country;
    delete temp.certification_name;
    setCertificationDetails(temp);
    setOpenAddCertificationBody(!openAddCertificationBody);
  }

  function showAddCertificationBody() {
    return (
      <Container className={classes.modal1}>
        <h2 id="simple-modal-title">{certificationFields.addCertificationBody}</h2>
        <Grid id="top-row" container>
          <Grid id="top-row" xs={12} md={12} container direction="column">
            <Template payload={payload4} />
          </Grid>
        </Grid>
        <Grid
          id="top-row"
          container
          spacing={24}
          justify="center"
          alignItems="center"
        >
          <Grid item>
            <Button
              disabled={loading}
              label={loading ? "Loading..." : "Save"}
              onClick={CerificationAction}
            />
          </Grid>
          <Grid item>
            <Button label="Cancel" onClick={() => CertificationCancel()} />
          </Grid>
        </Grid>
      </Container>
    );
  }

  const payload1 = [
    {
      label: certificationsFields.location,
      required: true,
      type: "autocomplete",
      labelprop: "entityname",
      value: certificationDetails.location || '',
      error: validationError?.location,
      helperText: validationError?.location,
      options: locationList || [],
      onChange: handleChangeLocation,
      sm: 6,
    },
    {
      label: certificationsFields.type_of_certification,
      type: "input",
      required: true,
      disabled:true,
      value: certificationDetails.type_of_certification || '',
      error: validationError?.type_of_certification,
      helperText: validationError?.type_of_certification,
      onChange: (e) => handleChange(e.target.value, "type_of_certification"),
      sm: 6,
    },
    {
      label: certificationsFields.certification_body,
      required: true,
      disabled:true,
      type: "autocomplete",
      labelprop: "certification_name",
      error: validationError?.certificationBody,
      helperText: validationError?.certificationBody,
      value: certificationDetails?.certificationBody || '',
      options: certificationList || [],
      onChange: handleChangeBody,
      sm: 6,
    },
    // {
    //   label: "+ Add",
    //   type: "button",
    //   onClick: AddCertifictaionBody,
    //   style: {
    //     minWidth: "70px",
    //     height: "55px",
    //     fontSize: "15px",
    //     marginBottom: "0px",
    //   },
    //   sm: 1,
    // },
    {
      label: certificationsFields.status,
       required: true,
      type: "autocomplete",
      labelprop: "status",
      value: certificationDetails.status || '',
      error: validationError?.status,
      helperText: validationError?.status,
      options: status || [],
      onChange: handleChangestatus,
      sm: 6,
    },
    {
      label: certificationsFields.comments,
      type: "input",
      multiline: true,
      rows: 3,
      value: certificationDetails.comments || '',
      onChange: (e) => handleChange(e.target.value, "comments"),
      sm: 6,
    },
  ];
  const payload2 = [
    {
      label: certificationsFields.issued_date,      
      type: "yearDatepicker",
      InputProps: { readOnly: true },
      value: certificationDetails.issued_date || null,
      required: true,
      disabled:true,
      error: validationError?.issued_date,
      helperText: validationError?.issued_date,
      onChange: (val) => handleDateChange(val, "issued_date"),
      sm: 6,
    },
    {
      label: certificationsFields.expiry_date,
      type: "yearDatepicker",
      InputProps: { readOnly: true },
      required: true,
      disabled:true,
      value: certificationDetails.expiry_date || null,
      error: validationError?.expiry_date,
      helperText: validationError?.expiry_date,
      onChange: (val) => handleDateChange(val, "expiry_date"),
      sm: 6,
    },
    {
      label: certificationFields.next_audit_date,
      type: "yearDatepicker",
      InputProps: { readOnly: true },
      required: true,
      value: certificationDetails.next_audit_date || null,
        // ? certificationDetails.next_audit_date
        // : currentDate(),
        error: validationError?.next_audit_date,
        helperText: validationError?.next_audit_date,
      onChange: (val) => handleDateChange(val, "next_audit_date"),
      sm: 6,
    },
    {
      label: certificationsFields.alert_initation_date,
      type: "yearDatepicker",
      InputProps: { readOnly: true },
      disabled: true,
      value: certificationDetails.alert_initation_date1 || null,
      onChange: (val) => handleDateChange(val, "alert_initation_date1"),
      sm: 6,
    },
  ];
  const payload3 = [
    {
      type: "file",
      disabled: disableInvoice,
      onChange: (e) => handleFileChange(e),
      required: true,
      sm: 6,
      className: classes.fileInput,
      InputLabelProps: { shrink: true },
    },
    {
      type: "label",
      value: certificationDetails?.doc_name,
      sm: 6,
      style: {position: 'relative', top: '2rem'}
    },    
  ];
  const EditCertifications = async (e) => {
    e.preventDefault();

    const message = commonStrings.pleaseEnterValidDetails;
    let errorObj = {};
    if (_.isEmpty(certificationDetails.type_of_certification)) {
      errorObj = { ...errorObj, type_of_certification: message };
    }
    if (_.isEmpty(certificationDetails.location)) {
      errorObj = { ...errorObj, location: message };
    }
    if (_.isEmpty(certificationDetails.certificationBody)) {
      errorObj = { ...errorObj, certificationBody: message };
    }
    if (_.isEmpty(certificationDetails.issued_date)) {
      errorObj = { ...errorObj, issued_date: message };
    }
    if (_.isEmpty(certificationDetails.expiry_date)) {
      errorObj = { ...errorObj, expiry_date: message };
    }
    if (_.isEmpty(certificationDetails.status)) {
      errorObj = { ...errorObj, status: message };
    }
    if (_.isEmpty(certificationDetails.next_audit_date)) {
      errorObj = { ...errorObj, next_audit_date: message };
    }
    if (_.isEmpty(uploadedFile)) {
      errorObj = { ...errorObj, uploadedFile: message };
    }

    setValidationError(errorObj);
    // if (!_.isEmpty(errorObj)) {
    //   setValidationError(errorObj);
    // }
    if (!_.isEmpty(errorObj)) {
      // try {
      //   setValidationError(errorObj);
      //   console.log("errorObj::", errorObj)
      //   const errorMessage = { message: "Please fill all mandatory fields" };
      //   throw errorMessage;
      // } catch (err) {
        setSnack({
          open: true,
          message: commonStrings.fieldMissed,
          severity: "error",
        });
      // }
    } else {
      setLoading(true);
      let data = {
        location: certificationDetails.location?.entityname,
        cert_id:certificationId,
        // type_of_certification: certificationDetails.type_of_certification,
        certification_name: certificationDetails.certificationBody?.certification_name,
        // cert_body_id: certificationDetails.certificationBody?.cert_body_id,
        status: certificationDetails.status.status,
        comments: certificationDetails.comments,
        // issued_date: formatDate(convertDateintoTZ(new Date(certificationDetails.issued_date))),
        // expiry_date: formatDate(convertDateintoTZ(new Date(certificationDetails.expiry_date))),
        next_audit_date: formatDate(convertDateintoTZ(new Date(certificationDetails.next_audit_date))),
        // alert_initation_date1: formatDate(convertDateintoTZ(new Date(certificationDetails.alert_initation_date1))),
        // alert_initation_date2: formatDate(convertDateintoTZ(new Date(certificationDetails.alert_initation_date2))),
        fileContent: uploadedFile?.file,
        modified_by: currentUserDetails.id,
        doc_name: uploadedFile?.name,
        document_update: documentUpdated
      };
      console.log("dataa::", oldData, certificationDetails);
  
      try {
        const modRes = {...certificationDetails};
        modRes.location = modRes?.location?.entityname || '';
        modRes.status = modRes?.status?.status || '';
        modRes.certification_name = modRes?.certificationBody?.certification_name;
        const modOld = {...oldData};
        modOld.location = modOld?.location?.entityname || '';
        modOld.status = modOld?.status?.status || '';
        modOld.certification_name = modOld?.certificationBody?.certification_name;        
        let changedValues = [];
          let allValues = []
          _.forOwn(modRes, function(value, key) {
            console.log("www",value,"===",key)
            if (key === "next_audit_date") {
              const formatDate = (date) => {
                return new Date(date).toISOString().split("T")[0];
              };
          
              value = formatDate(value); 
              modOld[key] = formatDate(modOld[key]);
            }
            if(!_.isEqual(value, modOld[key])) {
              allValues.push({
                    field: key,
                    newValue: value.toString(),
                    oldValue: modOld[key].toString()
                });
            }
          })
          changedValues = {...changedValues, allValues}
          const combinedValues = Object.values(changedValues).reduce((acc, val) => acc.concat(val), []);
          let auditPayload = combinedValues.map(obj => {
            return {
                parentId: certificationId,
                ...obj,
                createdBy: getCurrentUserDetails().name
            };
        });

        auditPayload.map((item, index) => {
          console.log('item::new', item, typeof item.newValue)          
          if(typeof item.newValue === 'object' && typeof item.oldValue === 'object'){
            if(item.oldValue?.entityname !== undefined) {
              item.newValue = item.newValue.entityname;
              item.oldValue = item.oldValue.entityname;
            }
            if(item.oldValue?.status !== undefined) {
              item.newValue = item.newValue.status;
              item.oldValue = item.oldValue.status;
            }
          }
        })
        let response = await getcertificateupdate(data);
        if (response) {
          setSnack({
            open: true,
            message: certificationFields.certificateUpdationSuccess,
          });
          let payload1 = {
            "certificationNotification": true,
            "feature_category": "Certificate",
            "status": `${certificationDetails.certificationBody?.certification_name} Certificate Updated by ${currentUserDetails?.name}` ,
            "user_id": getCurrentUserDetails().id,
          }
  
          const response1 =  getcreatenotification(payload1);
          if(response1) {
            setSnack({
              open: true,
              message: commonStrings.notificationSent,
            });
          }
          // setGcDetails({});
          setTimeout(() => {
            navigate(routeBuilder('certification',certificationId, 'view'))
          }, 1500);
        }
          
             var audit = auditparams(auditPayload, certificationId,getCurrentUserDetails().name); 
         let auditRes =  getcreateAuditlog(audit);
        if (auditRes) {
          setSnack({
            open: true,
            message: commonStrings.auditSuccess,
          });
          // setTimeout(() => {
          //   // navigate(-1)
          //   navigate(`/gc/${gcId}/view`);
          // }, 2000);
        }
        
      } catch (e) {
        setSnack({
          open: true,
          message: commonStrings.serverError, //e.response?.data
          severity: commonStrings.error,
        });
      } finally {
        setLoading(false);
      }
      
      setDisableCreate(true);
    }


  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      {showSnack.open && (
        <Snackbar
          {...showSnack}
          handleClose={() =>
            setSnack({ open: false, message: "", severity: "" })
          }
        />
      )}
      <Accordion defaultExpanded={true}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid id="top-row" container>
            <Grid item md={12} xs={12} className="item">
              <Typography>{certificationSections.system_info}</Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Template payload={payload1} />
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded={true}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid id="top-row" container>
            <Grid item md={12} xs={12} className="item">
              <Typography>{certificationSections.cert_uploaded_versions}</Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Template payload={payload2} />
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded={true}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid id="top-row" container>
            <Grid item md={12} xs={12} className="item">
              <Typography>{certificationSections.cert_uploaded_versions}</Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Template payload={payload3} />
        </AccordionDetails>
      </Accordion>
      
      <Grid container xs={12} md={12} className={classes.actionRow} justify="center">
        <Grid item>
          <Button
            disabled={loading}
            label={loading ? "Loading..." : "Save"}
            onClick={EditCertifications}
          />
        </Grid>
        <Grid item>
          <Button label="Cancel" onClick={() => navigate(-1)} />
        </Grid>
      </Grid>

      <SimpleModal
        open={openAddCertificationBody}
        handleClose={() =>
          setOpenAddCertificationBody(!openAddCertificationBody)
        }
        body={showAddCertificationBody}
      />
    </form>
  );
};
export default EditCertification;
